/**
 * Splits scheduler events into [allDayEvents, timedEvents].
 * Mirrors existing agenda behavior to avoid any rendering changes.
 *
 * @param {Array} events
 * @returns {[Array, Array]}
 */
export const splitAllDayAndTimedEvents = (events = []) => {
  return events.reduce(
    (acc, item) => {
      if (item?.isAllDayEvent) {
        acc[0].push(item);
      } else {
        acc[1].push(item);
      }
      return acc;
    },
    [[], []],
  );
};

/**
 * Returns true when an agenda payload has no visible items.
 *
 * @param {Array} agenda
 * @returns {boolean}
 */
export const isAgendaEmptyData = (agenda) => {
  if (!agenda || agenda.length === 0) return true;

  return agenda.every(
    (item) =>
      (!item?.appointments || item.appointments.length === 0) &&
      (!item?.leaves || item.leaves.length === 0) &&
      (!item?.schedulerBusySlots || item.schedulerBusySlots.length === 0) &&
      (!item?.schedulerEvents || item.schedulerEvents.length === 0) &&
      (!item?.appointmentSlots || item.appointmentSlots.length === 0) &&
      (!item?.holidayList || item.holidayList === null),
  );
};

